import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { CheckboxViewComponent } from './checkbox-view.component';
import { InputContainerComponent } from '../input-container/input-container.component';
import { ControlsIconsModule } from '../icons.module';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, InputContainerComponent, ControlsIconsModule],
    selector: 'wd-checkbox-input',
    templateUrl: 'checkbox-input.component.html',
    styleUrls: ['../styles/checkbox-view.component.css', '../styles/input.component.css', '../styles/view.component.css'],
})
export class CheckboxInputComponent extends CheckboxViewComponent {
	@ViewChild('inputValue') inputValue!: NgModel;

	onKeyPressed(event: KeyboardEvent) {
		if (event.key === ' ')
			this.onClicked();
	}

	onClicked($event?: MouseEvent): void {
		this.model = !this.model;
		this.vs.dirty.next(true);
		this.modelChange.emit(this.model);
	}

	override helpText(): string {
		if (this.inputValue === undefined || this.inputValue.touched) return super.helpText();
		return '';
	}
}
